import { Node, NodeProps } from "@xyflow/react";
import { useSetAtom } from "jotai";
import {
  assetStepTitlePlaceholderTextAtom,
  DefaultNodeData,
} from "@zapier/canvas-state";

import { AssetNodeProps } from "../AssetNodeSkeleton/AssetNodeDeterminer";
import { AssetNodeSkeleton } from "../AssetNodeSkeleton";
import {
  DEFAULT_CHATBOT_NODE_BACKGROUND_COLOR,
  DEFAULT_CHATBOT_NODE_COLOR,
} from "@zapier/canvas-constants";
import { useAssetPreload } from "../../../../hooks/useAssetPreload";

export function ChatbotNode(
  props: NodeProps<Node<DefaultNodeData>> & AssetNodeProps,
) {
  const { isViewOnlyMode } = props;

  const handleMouseEnter = useAssetPreload({
    assetType: "chatbot",
    nodeData: props.data,
  });
  const getPlaceholder = useSetAtom(assetStepTitlePlaceholderTextAtom);
  const placeholder = getPlaceholder("chatbot");
  return (
    <AssetNodeSkeleton
      {...props}
      data={{
        ...props.data,
        color: props.data.color || DEFAULT_CHATBOT_NODE_COLOR,
      }}
      placeholder={isViewOnlyMode ? "" : placeholder}
      iconName="navAIChatbot"
      backgroundColor={
        props.backgroundColor || DEFAULT_CHATBOT_NODE_BACKGROUND_COLOR
      }
      onMouseEnter={handleMouseEnter}
    />
  );
}
